import { FontFamily } from '@tiptap/extension-text-style';
import { ModalProps } from 'flowbite-react';
import { isObject } from 'lodash';
import { PropsWithChildren } from 'react';
import ModalWrapper from 'src/components/modal/modalWrapper';
import { ActivityLog } from 'src/types/activityLog.type';
import { twMerge } from 'tailwind-merge';

type SectionWrapperProps = PropsWithChildren & {
   className?: string;
};

const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, className }) => {
   return <div className={twMerge('break-inside-avoid', className)}>{children}</div>;
};

const SectionTitle: React.FC<{ title: string; className?: string }> = ({ className, title }) => {
   return <h3 className={twMerge('text-black font-bold text-l-xl mb-7.5 w-full text-center', className)}>{title}</h3>;
};

type JsonViewerProps = {
   data: object;
};

const JsonViewer = ({ data }: JsonViewerProps) => {
   return (
      <pre className="text-sm text-black overflow-x-auto whitespace-pre-wrap leading-5" style={{ fontFamily: "'Titillium Web', sans-serif" }}>
         {JSON.stringify(data, null, 3)}
      </pre>
   );
};

const SectionKeyValue: React.FC<{
   title: string;
   value: string | React.ReactNode | object;
   className?: string;
   valueClassName?: string;
}> = ({ title, value, className, valueClassName }) => {
   return (
      <div className={twMerge('grid grid-cols-[1fr_2fr] sm:grid-cols-[1fr_4fr] gap-x-2.5', className)}>
         <div className="text-black text-sm title">{title}</div>
         {isObject(value) ? (
            <JsonViewer data={value as object} />
         ) : (
            <div className={twMerge('text-black text-sm value truncate whitespace-pre-wrap', valueClassName)}>{value ?? '-'}</div>
         )}
      </div>
   );
};

type ViewActivityLogModalProps = ModalProps & {
   log?: ActivityLog;
};

const ViewActivityLogModal = ({ show, onClose, log }: ViewActivityLogModalProps) => {
   return (
      <ModalWrapper onClose={onClose} show={show} size="md" theme={{ root: { sizes: { md: 'max-w-[800px]' } } }}>
         <SectionWrapper>
            <SectionTitle title="View Activity Log" />
            <SectionKeyValue title="log.id" value={log?.logId ?? '-'} valueClassName="font-semibold" />
            <SectionKeyValue title="log.created" value={log?.created ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="log.organizationId" value={log?.organizationId ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="log_org.name" value={log?.organizationName ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="log_org.slug" value={log?.organizationSlug ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="requestType" value={log?.requestType ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="requestBody" value={log?.requestBody ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="userId" value={log?.userId ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="user.emailAddress" value={log?.email ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="user.firstName" value={log?.firstName ?? '-'} className="mt-3.75" />
            <SectionKeyValue title="user.lastName" value={log?.lastName ?? '-'} className="mt-3.75" />
         </SectionWrapper>
      </ModalWrapper>
   );
};
export default ViewActivityLogModal;
